import { inject, injectable } from 'inversify';
import { SuspendDataStore, SuspendDataStoreSymbol, SuspendDataStateStore } from '@/app/tracking/common';
import { QuestionAttemptsTrackingState, defaultQuestionAttemptsTrackingState } from './question-attempts-tracking-state';
import { QuestionAttemptCommand, questionAttemptReducer } from './question-attempts-state-reducer'

interface QuestionAttemptsSuspendData {
  questionAttempts: QuestionAttemptsTrackingState[];
}

@injectable()
export class QuestionAttemptsSuspendDataStore {

  private store: SuspendDataStateStore<QuestionAttemptsTrackingState, unknown, QuestionAttemptCommand>;

  constructor(
    @inject(SuspendDataStoreSymbol)
    suspendDataStore: SuspendDataStore<QuestionAttemptsSuspendData>) {

    this.store = new SuspendDataStateStore(
      () => suspendDataStore.get2('questionAttempts'),
      (data: QuestionAttemptsTrackingState[]) => suspendDataStore.update2('questionAttempts', data),
      (id) => defaultQuestionAttemptsTrackingState(id),
      questionAttemptReducer);
  }

  public async query(ids: string[] | 'all') {
    return this.store.query(ids);
  }

  public async execute(command: QuestionAttemptCommand) {
    await this.store.execute(command);
  }
}
